import { render, staticRenderFns } from "./ShareACopy.vue?vue&type=template&id=caac73ee&scoped=true"
import script from "./ShareACopy.vue?vue&type=script&lang=js"
export * from "./ShareACopy.vue?vue&type=script&lang=js"
import style0 from "./ShareACopy.vue?vue&type=style&index=0&id=caac73ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caac73ee",
  null
  
)

export default component.exports